import { forwardRef } from 'react';

// prop-types is a library for typechecking of props

// Custom styles for MDInput
import { InputAdornment } from '@mui/material';
import FunctionsIcon from '@mui/icons-material/Functions';
import MDInput from 'components/MDInput';

const MDFormulaInput = forwardRef((props, ref) => {
  return (
    <MDInput
      ref={ref}
      {...props}
      InputProps={{
        ...props.InputProps, // Merge any existing InputProps
        endAdornment: (
          <InputAdornment position="end">
            <FunctionsIcon />
          </InputAdornment>
        )
      }}
    />
  );
});

MDFormulaInput.defaultProps = {
  ...MDInput.defaultProps
};

MDFormulaInput.propTypes = {
  ...MDInput.propTypes
};

export default MDFormulaInput;
